import { render, staticRenderFns } from "./ModalAnnouncementDetail.vue?vue&type=template&id=b20486a0&scoped=true&"
import script from "./ModalAnnouncementDetail.vue?vue&type=script&lang=js&"
export * from "./ModalAnnouncementDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModalAnnouncementDetail.vue?vue&type=style&index=0&id=b20486a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20486a0",
  null
  
)

export default component.exports